export const Divider = () => {
  return <div className="h-sm w-0 border-l border-neutral" data-sentry-component="Divider" data-sentry-source-file="Divider.tsx" />;
};